import LLInput from '@next-app/components/elements/LLInput/LLInput';
import LLRadio from '@next-app/components/elements/LLRadio/LLRadio';
import Button from '@next-app/components/elements/Button/Button';

import { useEffect, useState } from 'react';
import { LISTS } from '@next-app/constants/ShoppingCartConstants';
import { IShoppingList } from '@next-app/lib/features/ShoppingCart/ShoppingCart.interface';
import { DynamicDTMEvent } from '@next-app/utils/dtm-event';
import LLHeading from '@next-app/components/elements/LLHeading/LLHeading';
import { checkoutPageConstant } from '@next-app/constants/CheckoutConstants';
import Link from '@next-app/components/elements/Link/Link';
import Conditional from '@next-app/components/Conditional';

interface ICreateListProps {
  handleCreateListBtn: Function;
  handleCreateListOnCancel: Function;
  id: string;
  allProductIdsForList?: string[];
  allShoppingListForList: IShoppingList[];
  isCreateModal: boolean;
  saveAllItem: boolean;
  error: string;
  setError: Function;
  listName: string;
  setListName: Function;
  fromPage?: string;
}
const CreateListModal = (props: ICreateListProps) => {
  const {
    handleCreateListBtn,
    handleCreateListOnCancel,
    id,
    allProductIdsForList,
    allShoppingListForList,
    isCreateModal,
    saveAllItem,
    error,
    setError,
    listName,
    setListName,
    fromPage,
  } = props;

  const [listType, setListType] = useState(LISTS.LIST_TYPE.PRIVATE);
  const validateListNameInput = (input: string): string => {
    return input.replace(/[^a-zA-Z0-9\s~!@#$%^*()_=+|;:,.'?/-]/g, '');
  };

  useEffect(() => {
    DynamicDTMEvent({ event: 'createShoppingListStart' });
  }, []);

  return (
    <div
      className={`d-flex ${!isCreateModal ? 'p-ll-3 ll-bg-gray border-end border-start border-top border-bottom' : ''}`}
      key={`createListModal-${id}`}
    >
      <form className="flex-grow-1">
        <div className="row position-relative mb-ll-3 g-0">
          <LLInput
            key={`addList-${id}`}
            id={`addList-${id}`}
            name={'addList'}
            value={listName}
            maxLength={80}
            placeholder="List Name"
            onChange={(e) => {
              const validatedInput = validateListNameInput(e.target.value);
              setListName(validatedInput);
              setError('');
            }}
            errorMsg={error}
          />
        </div>
        <div
          className={`row g-0 ${isCreateModal ? 'll-bg-gray border-end border-start border-top border-bottom p-ll-3' : ''}`}
        >
          <LLHeading tagName="5" customClass="mb-ll-3">
            Privacy Options
          </LLHeading>
          <div className={`col-12 ${isCreateModal ? 'mb-ll-1' : 'col-md-6'}`}>
            <LLRadio
              id={`privateList-${id}`}
              value={LISTS.LIST_TYPE.PRIVATE}
              name="listType"
              checked={listType === LISTS.LIST_TYPE.PRIVATE}
              onChange={() => setListType(LISTS.LIST_TYPE.PRIVATE)}
              customClass="d-flex"
            >
              <p>
                <strong>Private</strong>
              </p>
              <p>
                Only viewable by you or those with whom you share your list.
              </p>
            </LLRadio>
          </div>
          <div className={`col-12 ${isCreateModal ? 'mt-ll-1' : 'col-md-6'}`}>
            <LLRadio
              id={`publicList-${id}`}
              value={LISTS.LIST_TYPE.PUBLIC}
              name="listType"
              checked={listType === LISTS.LIST_TYPE.PUBLIC}
              onChange={() => setListType(LISTS.LIST_TYPE.PUBLIC)}
              customClass="d-flex"
            >
              <p>
                <strong>Public</strong>
              </p>
              <p>
                Others can search for and view your list. This list is public
                and some of your information will be visible / searchable.
              </p>
            </LLRadio>
          </div>
          <Conditional if={isCreateModal}>
            <div className="mt-ll-3">
              For more details, view our{' '}
              <Link
                tabIndex={0}
                target="_blank"
                s_objectid="privacy-policy-page-footer-link"
                href={checkoutPageConstant.SEE_PRIVACY_POLICY_URL}
                className={`text-decoration-underline fs-xs ll-link-primary-link`}
              >
                Privacy Policy
              </Link>
            </div>
          </Conditional>
        </div>
        <div className="row g-0">
          <div
            className={`d-flex justify-content-md-end mt-4 gap-ll-3 ${fromPage == 'pdp' && !isCreateModal ? 'flex-row justify-content-end' : 'flex-column'} ${isCreateModal ? 'flex-column-reverse' : 'flex-md-row'}`}
          >
            <Button
              onClick={handleCreateListOnCancel}
              variant={isCreateModal ? 'ternary' : 'ternary-inverse'}
            >
              Cancel
            </Button>
            <Button
              variant={isCreateModal ? 'primary' : 'secondary'}
              onClick={() =>
                handleCreateListBtn(
                  listName,
                  listType,
                  setError,
                  allProductIdsForList,
                  allShoppingListForList,
                )
              }
            >
              {isCreateModal
                ? saveAllItem
                  ? 'Create List and Move All Items'
                  : 'Create List and Move Item'
                : 'Create List'}
            </Button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateListModal;
